import { ID } from '@griply/types';

export type CalendarEventOrderInput = {
  id: ID;
  isAllDay: boolean;
  isCompleted: boolean;
  isExternal: boolean;
  isGoalDeadline: boolean;
  start: number;
  title: string;
};

const getRank = (event: CalendarEventOrderInput): number => {
  if (event.isExternal) {
    return 0;
  }

  if (event.isGoalDeadline) {
    return 1;
  }

  return 2;
};

// Completed sinks only for all-day events (never the time grid); per-element keys stay transitive; id key keeps ties engine-deterministic.
export const compareCalendarEventOrder = (
  a: CalendarEventOrderInput,
  b: CalendarEventOrderInput,
): number =>
  Number(a.isCompleted && a.isAllDay) - Number(b.isCompleted && b.isAllDay) ||
  getRank(a) - getRank(b) ||
  a.start - b.start ||
  (a.title ?? '').localeCompare(b.title ?? '') ||
  a.id.localeCompare(b.id);
